import { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { useHasFinePointer } from "@/hooks/useHasFinePointer";

// Magnetic button: gently pulls toward the cursor when hovered.
// Falls back to a plain button on touch devices.
const MagneticButton = ({ children, as: As = "button", className = "", strength = 0.25, ...props }) => {
    const hasFinePointer = useHasFinePointer();
    const ref = useRef(null);
    const x = useMotionValue(0);
    const y = useMotionValue(0);
    const springX = useSpring(x, { stiffness: 220, damping: 18, mass: 0.35 });
    const springY = useSpring(y, { stiffness: 220, damping: 18, mass: 0.35 });

    const handleMove = (e) => {
        if (!hasFinePointer || !ref.current) return;
        const rect = ref.current.getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        x.set((e.clientX - cx) * strength);
        y.set((e.clientY - cy) * strength);
    };
    const handleLeave = () => {
        x.set(0);
        y.set(0);
    };

    return (
        <motion.div
            ref={ref}
            onMouseMove={handleMove}
            onMouseLeave={handleLeave}
            style={{ x: springX, y: springY, display: "inline-block" }}
        >
            <As className={className} {...props}>
                {children}
            </As>
        </motion.div>
    );
};

export default MagneticButton;
